import { Alert, Text } from '@cinesend/ui-kit'
import { useNavigate, useParams } from 'react-router-dom'
import useAuth from '../../hooks/use_auth'
import useStore from '../../hooks/use_store'
import useUtilities from '../../hooks/use_utilities'
import { assetStatus } from '../../constants/asset_statuses'
import { CHILD_ENTITY_LABEL, GROUP_ASSET_TYPES } from '../../constants/group_asset_types'
import { convertToLongDate } from '../../helpers/convert_date'
import SettingsCard from '../settings_card'
import Date from './date'

const Availability = ({ asset, cycleID }) => {
  const params = useParams()
  const navigate = useNavigate()
  const { updateModel } = useStore()
  const { user } = useAuth()
  const { assetTypes } = useUtilities()
  const isGroupAsset = GROUP_ASSET_TYPES.includes(asset.asset_type)
  const assetDateIssue = asset?.asset_issues?.find((issue) => issue.validator_group === 'date_order')
  const parentAssetType = assetTypes?.find((type) => type.value === asset.parent_asset_type)

  if (asset.asset_type === 'ad') return null

  const saveAsset = (data) =>
    updateModel.mutate(
      {
        endpoint: `cycles/${cycleID}/assets`,
        id: asset.id,
        data,
      },
      {
        onSuccess: (res) => {
          if (res.data.asset.id === asset.id) return
          const nextId = res.data.asset.id
          if (asset.asset_type === 'ad') {
            navigate(`/airlines/${params.airlineID}/cycles/${cycleID}/ads/clips/${nextId}/details`)
            return
          }
          if (params.parentAssetID && parentAssetType) {
            navigate(
              `/airlines/${params.airlineID}/cycles/${cycleID}/metadata/${parentAssetType.route_value}/${params.parentAssetID}/${asset.route_value}/${nextId}/details`
            )
            return
          }
          navigate(`/airlines/${params.airlineID}/cycles/${cycleID}/metadata/${asset.route_value}/${nextId}/details`)
        },
      }
    )

  return (
    <SettingsCard title='Availability'>
      {isGroupAsset ? (
        <div>
          <div className='grid gap-4 sm:grid-cols-2'>
            {[
              ['Start Date', asset.start_date],
              ['End Date', asset.end_date],
            ].map(([label, date]) => (
              <div key={label}>
                <Text as='p' variant='xs' tone='secondary' className='mb-1'>
                  {label}
                </Text>
                <Text as='p' variant='sm'>
                  {convertToLongDate(date)}
                </Text>
              </div>
            ))}
          </div>
          <Text as='p' variant='xs' tone='secondary' className='mt-2'>
            Derived from {CHILD_ENTITY_LABEL[asset.asset_type]}.
          </Text>
        </div>
      ) : (
        <div className='grid gap-4 sm:grid-cols-2'>
          <Date
            asset={asset}
            type='Start'
            saveAsset={saveAsset}
            disabled={
              [assetStatus.Holdover, assetStatus.Expiring].includes(asset.status) && !user.has_unrestricted_edit_role
            }
          />
          <Date asset={asset} type='End' saveAsset={saveAsset} />
        </div>
      )}
      {assetDateIssue ? (
        <Alert tone='error' size='sm'>
          {assetDateIssue.description}
        </Alert>
      ) : null}
    </SettingsCard>
  )
}

export default Availability
